// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RobiTest design tokens — bridge RT2 (--rt-*) to global theme tokens */

:root {
  /* Map shell primitives onto Cloudlight / Midnight tokens */
  --rt-primary: var(--primary);
  --rt-primary-hover: var(--primary-hover);
  --rt-primary-subtle: var(--primary-muted);
  --rt-primary-border: rgba(37, 99, 235, 0.22);

  --rt-success: var(--success);
  --rt-danger: var(--danger);
  --rt-warning: var(--warning);
  --rt-info: var(--info);

  --rt-bg: var(--bg-primary);
  --rt-surface: var(--surface);
  --rt-surface-raised: var(--surface-raised);
  --rt-surface-hover: var(--surface-hover);
  --rt-border: var(--border);
  --rt-border-subtle: var(--border-subtle);

  --rt-text: var(--text-primary);
  --rt-text-secondary: var(--text-secondary);
  --rt-text-muted: var(--text-muted);

  --rt-sidebar-w: 240px;
  --rt-sidebar-collapsed: 68px;
  --rt-topbar-h: 56px;
  --rt-shell-sidebar-offset: var(--rt-sidebar-collapsed);

  --rt-radius-sm: var(--radius-sm, 6px);
  --rt-radius-md: var(--radius-md, 8px);
  --rt-radius-lg: var(--radius-lg, 10px);

  --rt-text-xs: var(--text-xs, 0.75rem);
  --rt-text-sm: var(--text-sm, 0.8125rem);
  --rt-text-base: var(--text-base, 0.875rem);
  --rt-text-lg: var(--text-lg, 1rem);
  --rt-text-xl: var(--text-xl, 1.125rem);

  --rt-shadow-sm: var(--shadow-sm);
  --rt-font: var(--font-sans, inherit);
  --rt-transition: var(--transition-normal, 200ms ease);
}

[data-theme="dark"] {
  --rt-primary-border: rgba(59, 130, 246, 0.35);
}

.rt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: var(--rt-radius-md);
  border: 1px solid transparent;
  font-size: var(--rt-text-sm);
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background var(--rt-transition), border-color var(--rt-transition), color var(--rt-transition);
}

.rt-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.rt-btn--primary {
  background: var(--rt-primary);
  color: #fff;
}

.rt-btn--primary:hover:not(:disabled) {
  background: var(--rt-primary-hover);
}

.rt-btn--secondary {
  background: var(--rt-surface);
  border-color: var(--rt-border);
  color: var(--rt-text);
}

.rt-btn--secondary:hover:not(:disabled) {
  background: var(--rt-surface-hover);
}

.rt-btn--tertiary {
  background: transparent;
  color: var(--rt-text-secondary);
}

.rt-btn--tertiary:hover:not(:disabled) {
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
}

.rt-btn--danger {
  background: var(--danger-muted);
  color: var(--rt-danger);
  border-color: transparent;
}

.rt-btn--danger:hover:not(:disabled) {
  background: var(--rt-danger);
  color: #fff;
}

.rt-btn--sm {
  height: 28px;
  padding: 0 10px;
  font-size: var(--rt-text-xs);
}

.rt-btn--icon {
  width: 36px;
  padding: 0;
}

.rt-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: var(--bg-tertiary);
  color: var(--rt-text-secondary);
}

.rt-badge--success { background: var(--success-muted); color: var(--success); }
.rt-badge--danger { background: var(--danger-muted); color: var(--danger); }
.rt-badge--warning { background: var(--warning-muted); color: var(--warning); }
.rt-badge--info { background: var(--info-muted); color: var(--info); }
.rt-badge--primary { background: var(--primary-muted); color: var(--primary); }
.rt-badge--neutral { background: var(--bg-tertiary); color: var(--text-secondary); }

.rt-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.rt-status-dot--passed,
.rt-status-dot--success { background: var(--rt-success); }
.rt-status-dot--failed,
.rt-status-dot--danger { background: var(--rt-danger); }
.rt-status-dot--pending,
.rt-status-dot--warning { background: var(--rt-warning); }
.rt-status-dot--running,
.rt-status-dot--info { background: var(--rt-info); }
.rt-status-dot--neutral { background: var(--rt-text-muted); }

.rt-skeleton {
  background: linear-gradient(
    90deg,
    var(--bg-tertiary) 25%,
    var(--surface-hover) 50%,
    var(--bg-tertiary) 75%
  );
  background-size: 200% 100%;
  animation: rt-skel 1.2s ease-in-out infinite;
  border-radius: var(--rt-radius-sm);
}

@keyframes rt-skel {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.rt-empty {
  padding: 24px 16px;
  text-align: center;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-sm);
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,2DAA2D;EAC3D,4BAA4B;EAC5B,wCAAwC;EACxC,yCAAyC;EACzC,4CAA4C;;EAE5C,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;;EAEtB,0BAA0B;EAC1B,4BAA4B;EAC5B,0CAA0C;EAC1C,wCAAwC;EACxC,0BAA0B;EAC1B,wCAAwC;;EAExC,8BAA8B;EAC9B,0CAA0C;EAC1C,kCAAkC;;EAElC,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,sDAAsD;;EAEtD,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;;EAEtC,qCAAqC;EACrC,uCAAuC;EACvC,0CAA0C;EAC1C,kCAAkC;EAClC,sCAAsC;;EAEtC,gCAAgC;EAChC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,0GAA0G;AAC5G;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,oBAAoB,+BAA+B,EAAE,oBAAoB,EAAE;AAC3E,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,kBAAkB,6BAA6B,EAAE,kBAAkB,EAAE;AACrE,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,qBAAqB,8BAA8B,EAAE,4BAA4B,EAAE;;AAEnF;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;0BAC0B,6BAA6B,EAAE;AACzD;yBACyB,4BAA4B,EAAE;AACvD;0BAC0B,6BAA6B,EAAE;AACzD;uBACuB,0BAA0B,EAAE;AACnD,0BAA0B,gCAAgC,EAAE;;AAE5D;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* RobiTest design tokens — bridge RT2 (--rt-*) to global theme tokens */\n\n:root {\n  /* Map shell primitives onto Cloudlight / Midnight tokens */\n  --rt-primary: var(--primary);\n  --rt-primary-hover: var(--primary-hover);\n  --rt-primary-subtle: var(--primary-muted);\n  --rt-primary-border: rgba(37, 99, 235, 0.22);\n\n  --rt-success: var(--success);\n  --rt-danger: var(--danger);\n  --rt-warning: var(--warning);\n  --rt-info: var(--info);\n\n  --rt-bg: var(--bg-primary);\n  --rt-surface: var(--surface);\n  --rt-surface-raised: var(--surface-raised);\n  --rt-surface-hover: var(--surface-hover);\n  --rt-border: var(--border);\n  --rt-border-subtle: var(--border-subtle);\n\n  --rt-text: var(--text-primary);\n  --rt-text-secondary: var(--text-secondary);\n  --rt-text-muted: var(--text-muted);\n\n  --rt-sidebar-w: 240px;\n  --rt-sidebar-collapsed: 68px;\n  --rt-topbar-h: 56px;\n  --rt-shell-sidebar-offset: var(--rt-sidebar-collapsed);\n\n  --rt-radius-sm: var(--radius-sm, 6px);\n  --rt-radius-md: var(--radius-md, 8px);\n  --rt-radius-lg: var(--radius-lg, 10px);\n\n  --rt-text-xs: var(--text-xs, 0.75rem);\n  --rt-text-sm: var(--text-sm, 0.8125rem);\n  --rt-text-base: var(--text-base, 0.875rem);\n  --rt-text-lg: var(--text-lg, 1rem);\n  --rt-text-xl: var(--text-xl, 1.125rem);\n\n  --rt-shadow-sm: var(--shadow-sm);\n  --rt-font: var(--font-sans, inherit);\n  --rt-transition: var(--transition-normal, 200ms ease);\n}\n\n[data-theme=\"dark\"] {\n  --rt-primary-border: rgba(59, 130, 246, 0.35);\n}\n\n.rt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: var(--rt-radius-md);\n  border: 1px solid transparent;\n  font-size: var(--rt-text-sm);\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background var(--rt-transition), border-color var(--rt-transition), color var(--rt-transition);\n}\n\n.rt-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rt-btn--primary {\n  background: var(--rt-primary);\n  color: #fff;\n}\n\n.rt-btn--primary:hover:not(:disabled) {\n  background: var(--rt-primary-hover);\n}\n\n.rt-btn--secondary {\n  background: var(--rt-surface);\n  border-color: var(--rt-border);\n  color: var(--rt-text);\n}\n\n.rt-btn--secondary:hover:not(:disabled) {\n  background: var(--rt-surface-hover);\n}\n\n.rt-btn--tertiary {\n  background: transparent;\n  color: var(--rt-text-secondary);\n}\n\n.rt-btn--tertiary:hover:not(:disabled) {\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n}\n\n.rt-btn--danger {\n  background: var(--danger-muted);\n  color: var(--rt-danger);\n  border-color: transparent;\n}\n\n.rt-btn--danger:hover:not(:disabled) {\n  background: var(--rt-danger);\n  color: #fff;\n}\n\n.rt-btn--sm {\n  height: 28px;\n  padding: 0 10px;\n  font-size: var(--rt-text-xs);\n}\n\n.rt-btn--icon {\n  width: 36px;\n  padding: 0;\n}\n\n.rt-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--bg-tertiary);\n  color: var(--rt-text-secondary);\n}\n\n.rt-badge--success { background: var(--success-muted); color: var(--success); }\n.rt-badge--danger { background: var(--danger-muted); color: var(--danger); }\n.rt-badge--warning { background: var(--warning-muted); color: var(--warning); }\n.rt-badge--info { background: var(--info-muted); color: var(--info); }\n.rt-badge--primary { background: var(--primary-muted); color: var(--primary); }\n.rt-badge--neutral { background: var(--bg-tertiary); color: var(--text-secondary); }\n\n.rt-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.rt-status-dot--passed,\n.rt-status-dot--success { background: var(--rt-success); }\n.rt-status-dot--failed,\n.rt-status-dot--danger { background: var(--rt-danger); }\n.rt-status-dot--pending,\n.rt-status-dot--warning { background: var(--rt-warning); }\n.rt-status-dot--running,\n.rt-status-dot--info { background: var(--rt-info); }\n.rt-status-dot--neutral { background: var(--rt-text-muted); }\n\n.rt-skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--bg-tertiary) 25%,\n    var(--surface-hover) 50%,\n    var(--bg-tertiary) 75%\n  );\n  background-size: 200% 100%;\n  animation: rt-skel 1.2s ease-in-out infinite;\n  border-radius: var(--rt-radius-sm);\n}\n\n@keyframes rt-skel {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.rt-empty {\n  padding: 24px 16px;\n  text-align: center;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
